import ModalCuotas from "@/erp/sale/asesor/preventa/shared/component/modal_cuotas/ModalCuotas";
import { gridSizeMdLg12, gridSizeMdLg3 } from "@/shared";
import { CustomNumberTextField, CustomTextField, CustomTextFieldNoForm } from "@/shared/components/ui";
// import { MaterialTransferido } from "@/shared/interfaces";
import { IPreventaCorporativoForm2 } from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface"
// import DeleteIcon from '@mui/icons-material/Delete';
import { Grid } from "@mui/material";
import { UseFormReturn } from "react-hook-form"

interface TabServiciosAdicionalesCorporativoProps {
  form: UseFormReturn<IPreventaCorporativoForm2, any, IPreventaCorporativoForm2>
  disabledAll?: boolean;
  enableEdit?: boolean;
}
export default function TabServiciosAdicionalesCorporativo({
  form,
  // disabledAll=false,
  enableEdit=false
}: TabServiciosAdicionalesCorporativoProps) {

 
  

  return (
    <Grid item container {...gridSizeMdLg12} spacing={3}>




      <Grid item container spacing={3} {...gridSizeMdLg12} justifyContent={'start'} alignContent={'start'}>

        <CustomTextField
          control={form.control}
          name="num_ips_publicas"
          defaultValue={form.getValues().num_ips_publicas||"0"}
          size={gridSizeMdLg3}
          label={'Número de IPs públicas'}
          error={form.formState.errors.num_ips_publicas}
          helperText={form.formState.errors.num_ips_publicas?.message}
          disabled={!enableEdit}
        />
        <CustomNumberTextField
          control={form.control}
          name="num_ips_publicas_facturadas"
          defaultValue={form.getValues().num_ips_publicas_facturadas}
          onlyInteger={true}
          size={gridSizeMdLg3}
          label={'Número de IPs públicas Facturadas'}
          error={form.formState.errors.num_ips_publicas_facturadas}
          helperText={form.formState.errors.num_ips_publicas_facturadas?.message}
          disabled={false}
        />
        <CustomNumberTextField
          control={form.control}
          name="costo_valor_ip_facturado"
          defaultValue={"20"}
          size={gridSizeMdLg3}
          label={'Valor IPs Facturadas ($)'}
          error={form.formState.errors.costo_valor_ip_facturado}
          helperText={form.formState.errors.costo_valor_ip_facturado?.message}
          disabled={!enableEdit}
        />
        <CustomTextFieldNoForm
          value={
            form.watch().num_ips_publicas_facturadas&&form.getValues().costo_valor_ip_facturado?
            ((parseFloat(form.getValues().num_ips_publicas_facturadas)||0)*(form.getValues().costo_valor_ip_facturado||0)).toFixed(2)
            :0
          }
          size={gridSizeMdLg3}
          label={'Valor a Pagar ($)'}
          disabled={true}
          required={false}
        />
        {/* {
          isLoaginIPV4Groups?
          <LoaderComponent/>
          :
          <IPv4DetailsCellSelect formToAddIps={form} availableIps={dataIPV4Groups?.data.data?.[0]?.ips_disponibles || []}/>
        } */}



        
        <ModalCuotas />
        {/* <FormCoordendas
          form={form}
          label="Coordendas de la Empresa"
          name="coordenada_empresa"

          defaultValue={form.getValues().coordenada_empresa}
        /> */}


        {/* <CustomTextField
          disabled={false}
          control={control}
          name="direccion_empresa"
          defaultValue={form.getValues().direccion_empresa}
          size={gridSizeMdLg12}
          label={'Dirección de la Empresa'}
          error={errors.direccion_empresa}
          helperText={errors.direccion_empresa?.message}
        />
        
        <SampleCheckbox
          label="Es Demo"
          name="es_demo"
          control={control}
          defaultValue={!!form.getValues().es_demo}
          isState={false}
          size={gridSizeMdLg12}
        /> */}
      </Grid>
    </Grid>
  )

}




  //     {/* <Grid item container spacing={3} {...gridSizeMdLg12} justifyContent={'start'} alignContent={'start'}> */}
  //     <Grid item {...gridSizeMdLg3}>
  //     {/* <SampleCheckbox
  //       label='Seguridad Informática'
  //       control={form.control}
  //       name='seguridad_perimetral'
  //       defaultValue={form.getValues().seguridad_perimetral || false}
  //       onChangeValue={(e) => {
  //         form.reset({ ...form.getValues(), seguridad_perimetral: e, costo_seguridad_perimetral:undefined })
  //       }}
  //       size={gridSizeMdLg12}
  //       disabled={!enableEdit}
  //     /> */}
  //     {/* <CustomNumberTextField
  //       control={form.control}
  //       name="costo_seguridad_perimetral"
  //       defaultValue={form.getValues().costo_seguridad_perimetral}
  //       size={gridSizeMdLg12}
  //       label={'Costo Seguridad Informática'}
  //       error={form.formState.errors.costo_seguridad_perimetral}
  //       helperText={form.formState.errors.costo_seguridad_perimetral?.message}
  //       disabled={!form.watch().seguridad_perimetral || !enableEdit}
  //       sxInputText={{mt:1}}
  //     /> */}
  //   </Grid>
  //   <Grid item {...gridSizeMdLg3}>
  //     {/* <SampleCheckbox
  //       label='Fibra Oscura'
  //       control={form.control}
  //       name='fibra_oscura'
  //       defaultValue={form.getValues().fibra_oscura || false}
  //       onChangeValue={(e) => {
  //         form.reset({ ...form.getValues(), fibra_oscura: e, costo_fibra_oscura:undefined })
  //       }}
  //       size={gridSizeMdLg12}
  //       disabled={!enableEdit}
  //     /> */}
  //     {/* <CustomNumberTextField
  //       control={form.control}
  //       name="costo_fibra_oscura"
  //       defaultValue={form.getValues().costo_fibra_oscura}
  //       size={gridSizeMdLg12}
  //       label={'Costo Fibra Oscura'}
  //       error={form.formState.errors.costo_fibra_oscura}
  //       helperText={form.formState.errors.costo_fibra_oscura?.message}
  //       disabled={!form.watch().fibra_oscura || !enableEdit}
  //       sxInputText={{mt:1}}
  //     /> */}
  //   </Grid>
  //   <Grid item {...gridSizeMdLg3}>
  //     {/* <SampleCheckbox
  //       size={gridSizeMdLg12}
  //       label='Redes Gestionadas'
  //       control={form.control}
  //       name='wifi_gestionado'
  //       defaultValue={form.getValues().wifi_gestionado || false}
  //       onChangeValue={(e) => {
  //         form.reset({ ...form.getValues(), wifi_gestionado: e, costo_wifi_gestionado:undefined })
  //       }}
  //       disabled={!enableEdit}
  //     /> */}
  //     {/* <CustomNumberTextField
  //       control={form.control}
  //       name="costo_wifi_gestionado"
  //       defaultValue={form.getValues().costo_wifi_gestionado}
  //       size={gridSizeMdLg12}
  //       label={'Costo Redes Gestionadas'}
  //       error={form.formState.errors.costo_wifi_gestionado}
  //       helperText={form.formState.errors.costo_wifi_gestionado?.message}
  //       disabled={!form.watch().wifi_gestionado || !enableEdit}
  //       sxInputText={{mt:1}}
  //     /> */}

  //   </Grid>
  //   <Grid item {...gridSizeMdLg3}>
  //     {/* <SampleCheckbox
  //       size={gridSizeMdLg12}
  //       label='Cableado Estructurado'
  //       control={form.control}
  //       name='cableado_interno'
  //       defaultValue={form.getValues().cableado_interno || false}
  //       onChangeValue={(e) => {
  //         form.reset({ ...form.getValues(), cableado_interno: e, costo_cableado_interno:undefined })
  //       }}
  //       disabled={!enableEdit}
  //     /> */}
  //     {/* <CustomNumberTextField
  //       control={form.control}
  //       name="costo_cableado_interno"
  //       defaultValue={form.getValues().costo_cableado_interno}
  //       size={gridSizeMdLg12}
  //       label={'Costo Cableado Estructurado'}
  //       error={form.formState.errors.costo_cableado_interno}
  //       helperText={form.formState.errors.costo_cableado_interno?.message}
  //       disabled={!form.watch().cableado_interno || !enableEdit}
  //       sxInputText={{mt:1}}
  //     /> */}
  //   </Grid>
  //   <Grid container item spacing={2} {...gridSizeMdLg12}>
  //     {/* <SampleCheckbox
  //       size={gridSizeMdLg3}
  //       label='Plan TVMAX'
  //       control={form.control}
  //       name='plan_tvmax_bool'
  //       defaultValue={form.getValues().plan_tvmax_bool || !!form.getValues().plan_tvmax || false}
  //       onChangeValue={(e) => {
  //         form.reset({ ...form.getValues(), plan_tvmax_bool: e, codigo_plan_tvmax:"", usuarios_plan_tvmax:0,  plan_tvmax:null })
  //       }}
  //       disabled={!enableEdit}
  //     /> */}
  //     {/* {
  //       form.getValues().plan_tvmax_bool || !!form.getValues().plan_tvmax?
  //       <>
  //       <Grid container item spacing={2} {...gridSizeMdLg9}>
  //         <CustomAutocomplete<IPlanesTVMAX>
  //           label="Planes TVMAX"
  //           name="codigo_plan_tvmax"
  //           disabled={!enableEdit}
  //           options={PLANESTVMAX_OPTIONS}
  //           valueKey="nombre"
  //           actualValueKey="codigo"
  //           defaultValue={form.getValues().codigo_plan_tvmax || form.getValues()?.plan_tvmax?.codigo_plan_tvmax || ''}
  //           isLoadingData={false}
  //           control={form.control}
  //           error={form.formState.errors.codigo_plan_tvmax}
  //           helperText={form.formState.errors.codigo_plan_tvmax?.message}
  //           size={gridSizeMdLg4}
  //           onChangeRawValue={(e)=>{
  //             form.reset({
  //               ...form.getValues(),
  //               plan_tvmax:{
  //                 codigo_plan_tvmax:e.codigo,
  //                 nombre_plan_tvmax:e.nombre,
  //                 seniales_plan_tvmax:e.seniales,
  //                 costo_plan_tvmax: e.valor,
  //                 usuarios_plan_tvmax: form.getValues().usuarios_plan_tvmax||0,
  //                 min_usuarios:e.min_usuarios,
  //                 max_usuarios:e.max_usuarios,
  //               },
  //               usuarios_plan_tvmax_min: e.min_usuarios,
  //               usuarios_plan_tvmax_max: e.max_usuarios,
  //             })
  //           }}
  //         />
  //         <Grid item {...gridSizeMdLg4}>
  //           <CustomNumberTextField
  //             control={form.control}
  //             name="usuarios_plan_tvmax"
  //             defaultValue={form.getValues().usuarios_plan_tvmax || form.getValues()?.plan_tvmax?.usuarios_plan_tvmax || 0}
  //             size={gridSizeMdLg12}
  //             label={'Número de usuarios'}
  //             error={form.formState.errors.usuarios_plan_tvmax}
  //             helperText={form.formState.errors.usuarios_plan_tvmax?.message}
  //             onChangeValue={(e)=>
  //               form.reset({
  //                 ...form.getValues(), 
  //                 plan_tvmax:{
  //                   ...form.getValues().plan_tvmax,
  //                   usuarios_plan_tvmax:e
  //                 }
  //               }
  //             )}
  //           />
  //         </Grid>
  //         <Grid item {...gridSizeMdLg4}>
  //           <CustomTextFieldNoForm
  //             disabled
  //             size={gridSizeMdLg12}
  //             label={'Valor A Pagar Plan TVMAX'}
  //             value={
  //               form.getValues().plan_tvmax?.usuarios_plan_tvmax&&form.getValues().plan_tvmax?.costo_plan_tvmax?
  //               (form.getValues().plan_tvmax?.usuarios_plan_tvmax||0)*(form.getValues().plan_tvmax?.costo_plan_tvmax||0)
  //               :0
  //             }
  //           />
  //         </Grid>
  //       </Grid>
  //       </>
  //       :null
  //     } */}
  //   </Grid>
  //   {/* <Grid item {...gridSizeMdLg3}>
  //     <SampleCheckbox
  //       size={gridSizeMdLg3}
  //       label='Equipos Adicionales'
  //       control={form.control}
  //       name='check_equipos_adicionales'
  //       defaultValue={form.getValues().check_equipos_adicionales || false}
  //       onChangeValue={(e) => {
  //         form.reset({ ...form.getValues(), check_equipos_adicionales: e })
  //       }}
  //     />

  //     {
  //       form.watch().check_equipos_adicionales?
  //         <ModalProductoSelectComponente
  //           control={form.control}
  //           onChange={(e) => {
  //             const aux: MaterialTransferido = {
  //               id: e.id_producto,
  //               cantidad: 1,
  //               codigo: e.codigo,
  //               series: [],
  //               contiene_serie: false,
  //               producto_data: {
  //                 categoria_producto: e.categoria_producto,
  //                 codigo: e.codigo,
  //                 descripcion: e.descripcion,
  //                 stock_actual: e.stock_actual,
  //                 subcategoria_producto: e.subcategoria_producto,
  //                 precios: e.precios,
  //               },
  //             };
  //             const adicionalesMyE = form.getValues().equipos_adicionales!
  //             adicionalesMyE?.push(aux)
  //             form.reset({
  //               ...form.getValues(),
  //               equipos_adicionales:adicionalesMyE
  //             })
  //             // addSelectedItemProducto(aux, MaterialesKey.ingresoProductos);
  //           }}
  //         />
  //       :null
  //     }

  //   </Grid>
  //   {
  //     form.watch().check_equipos_adicionales?
  //       <Grid item {...gridSizeMdLg12}>
  //         <SampleTable<MaterialTransferido>
  //           rowNumber={true}
  //           columns={columnsCrearFactibilidadCorporativa}
  //           data={form.watch().equipos_adicionales||[]}
  //         />
  //       </Grid>
  //     :null
  //   } */}
    


    
  //   {/* ---------- android tv ---------- */}
  //   {/* {es_android_tv ? ( */}
  //     {/* <SampleCheckbox
  //       size={gridSizeMdLg4}
  //       label="ANDROID TV"
  //       control={form.control}
  //       name="es_android_tv"
  //       defaultValue={form.getValues().es_android_tv || false}
  //       onChangeValue={(e) => {
  //         form.reset({ ...form.getValues(), es_android_tv: e });
  //         if (!e)
  //           form.reset({
  //             ...form.getValues(),
  //             numero_cuotas_android_tv: 0,
  //             numero_cantidad_android_tv: 0,
  //           });
  //       }}
  //     />
  //     {form.getValues().es_android_tv && (
  //       <>
  //         <CustomAutocompleteArrString
  //           label="Cant."
  //           name="numero_cantidad_android_tv"
  //           options={CANTIDAD_CHOICE.filter((e) => +e <= 3)}
  //           control={form.control}
  //           defaultValue={
  //             form.getValues().numero_cantidad_android_tv || ""
  //           }
  //           error={form.formState.errors.numero_cantidad_android_tv}
  //           helperText={
  //             form.formState.errors.numero_cantidad_android_tv?.message?.toString() ??
  //             ""
  //           }
  //           isLoadingData={false}
  //           size={gridSizeMdLg3}
  //         />

  //         <CustomAutocompleteArrString
  //           label="Cuotas"
  //           name="numero_cuotas_android_tv"
  //           options={CUOTAS_CHOICE.filter((e) => e == 1 || e == 6)}
  //           control={form.control}
  //           defaultValue={
  //             form.getValues().numero_cuotas_android_tv || ""
  //           }
  //           error={form.formState.errors.numero_cuotas_android_tv}
  //           helperText={
  //             form.formState.errors.numero_cuotas_android_tv?.message?.toString() ??
  //             ""
  //           }
  //           isLoadingData={false}
  //           size={gridSizeMdLg3}
  //         />

  //         <Grid item {...gridSizeConst1}>
  //           <IconButton
  //             onClick={() => {
  //               getDataProducto({
  //                 slug: SystemParametersEnum.ANDROID_TV,
  //                 cantidad:
  //                   form.getValues().numero_cantidad_android_tv ??
  //                   0,
  //                 cuotas:
  //                   form.getValues().numero_cuotas_android_tv ?? 0,
  //               });
  //             }}
  //           >
  //             <Visibility />
  //           </IconButton>
  //         </Grid>
  //       </>
  //     )}
    
  //  */}
  // {/* </Grid> */}